import React, { FC } from "react";
import { Oval } from "react-loader-spinner";
import "./FormButtons.scss";

interface FromButtonsProps {
  onSubmit?: () => void;
  onCancel: () => void;
  submitLabel: string;
  cancelLabel: string;
  disabled: boolean;
  typeCancel: "button" | "submit";
  typeSubmit: "button" | "submit";
  submitIcon?: string;
  cancelIcon?: string;
  skipButton?: boolean;
  onSkip?: () => void;
  hideSubmitButton?: boolean;
  submitting?: boolean;
}

const FormButtons: FC<FromButtonsProps> = (props) => {
  return (
    <div className="form-buttons">
      <button
        onClick={props.onCancel}
        className="form-buttons__button cancel"
        type={props.typeCancel}
      >
        {props.cancelIcon && <img src={props.cancelIcon} alt="cancel_icon" />}
        {props.cancelLabel}
      </button>
      <div className="form-buttons__right">
        {props.skipButton && props.onSkip && (
          <button
            type="submit"
            className="form-buttons__skip"
            onClick={props.onSkip}
          >
            Skip
          </button>
        )}
        {!props.hideSubmitButton ? (
          <button
            onClick={props.onSubmit}
            className={
              props.disabled && !props.submitting
                ? `form-buttons__button form-buttons__button--disabled`
                : props.submitting
                ? `form-buttons__button form-buttons__button--loading`
                : `form-buttons__button form-buttons__button--hover`
            }
            disabled={props.disabled || props.submitting}
            type={props.typeSubmit}
          >
            {props.submitLabel}
            {props.submitIcon && (
              <img
                className={
                  props.submitting
                    ? "form-buttons__submit-icon--loading"
                    : "form-buttons__submit-icon"
                }
                src={props.submitIcon}
                alt="submit_icon"
              />
            )}
            {props.submitting && (
              <div className="form-buttons__loader">
                <Oval
                  color="#2bfda7"
                  height={26}
                  width={26}
                  strokeWidth={5}
                  secondaryColor="#b6b9be"
                />
              </div>
            )}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default FormButtons;
